export function NoResultButtons(selectLocation, labelText) {
  return {
    label: labelText,
    onClick: (e) => selectLocation('add')
  }
}
